import React from "react"
import { createGlobalStyle } from "styled-components"

const GlobalStyle = createGlobalStyle`
/*
=============== 
Variables
===============
*/
:root{
 --clr-purple: #593BA0;
 --clr-dark-purple: #28103C;
 --clr-white-purple: #F4EEFC;
 --clr-white-purple-rgba: rgba(244,238,252,0.08);
 --clr-gold: #D59F08;
 --clr-dark-gold: #B58808;
 --clr-dark-gold-2: #BD8D07;
 --clr-grey: #707070;
 --clr-grey-2: #3D3D3D;
 --clr-orange: rgb(252,76,2);

 --ff-primary: "Segoe UI", sans-serif;

 --fontSize-0: 1.4rem;
 --fontSize-1: 1.75rem;
 --fontSize-2: 2.2rem;
 --fontSize-3: 2.81rem;
 --fontSize-root: 16px;

 --lineHeight-none: 1;
 --lineHeight-tight: 1.1;
 --lineHeight-normal: 1.5;
 --lineHeight-relaxed: 1.625;

 --border-radius: 5px;
 --border-radius-secondary: 15px;

 --maxWidthPrimary: 1250px;

 --gapXS: 15px;
 --gapS: 35px;
 --gapM: 50px;
 --gapL: 75px;
 --gapXL: 100px;


 --box-shadow: 0px 3px 6px 0.5px rgba(0, 0, 0, 0.1);
 --box-shadow-secondary: 0px 3px 6px 0.5px rgba(0, 0, 0, 0.3);
}

/*
=============== 
Global Styles
===============
*/
*, 
:after,
:before {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.grecaptcha-badge { visibility: hidden; }

html {
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  line-height: var(--lineHeight-normal);
  font-size: var(--fontSize-root);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  font-family: var(--ff-primary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

main {
  display: block;
  width: 100%;
  height: auto;
  overflow: hidden;
  margin-top: var(--gapL);
  margin-bottom: var(--gapL);
  
  @media (max-width: 992px) {
    margin-top: var(--gapM);
  }
}


/**
 * 1. Change the font styles in all browsers.
 * 2. Remove the margin in Firefox and Safari.
 */

button,
input,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  margin: 0; /* 2 */
}

/**
 * Correct the inability to style clickable types in iOS and Safari.
 */

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}


/**
 * Remove the inner border and padding in Firefox.
 */

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
 * Restore the focus styles unset by the previous rule.
 */

button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */

button,
input {
  /* 1 */
  overflow: visible;
}

h1,h2,h3,h4,h5,h6{
  color: var(--clr-purple);
}

h1{
  font-size: var(--fontSize-3);
}

h2{
  font-size: var(--fontSize-2);
}

h3{
  font-size: var(--fontSize-1)
}

p{
  line-height: var(--lineHeight-relaxed);
}

a{
 text-decoration:none;
 color:inherit;
}

ul{
 list-style:none;
}

img{
  pointer-events: none;
}

svg{
  pointer-events: none;
}
`
export const wrapRootElement = ({ element }) => {
  return (
    <>
      <GlobalStyle />
      {element}
    </>
  )
}

export const onInitialClientRender = () => {
  setTimeout(function () {
    document.getElementById("___loader").style.display = "none"
  }, 50)
}
